import { Account } from "@components/account/profile";
import { ManagerSalesmanList } from "@components/team/salesman-list";
import { CustomerTrackingList } from "@components/tracking/customer-tracking-list";
import { SalesmanTrackingList } from "@components/tracking/salesman-tracking-list";
import { CustomerTypeEnum, CustomerTypeTypes } from "@hooks/dtos/user-dto";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { useState } from "react";

export function Dashboard() {
  const { customer } = ZuAuthStore();
  const [activeTab, setActiveTab] = useState("rastreios");

  const tabs = [
    { id: "rastreios", label: "Rastreios", component: CustomerTrackingList },
    ...([
      CustomerTypeEnum.SALESPERSON as CustomerTypeTypes,
      CustomerTypeEnum.MANAGER as CustomerTypeTypes,
    ].includes(customer?.customer?.type || CustomerTypeEnum.CUSTOMER)
      ? [
          {
            id: "rast_clientes",
            label: "Rastreios (Clientes)",
            component: SalesmanTrackingList,
          },
        ]
      : []),
    ...(customer?.customer?.type === CustomerTypeEnum.MANAGER
      ? [
          {
            id: "team_manager",
            label: "Equipe",
            component: ManagerSalesmanList,
          },
        ]
      : []),
    { id: "conta", label: "Conta", component: Account },
  ];

  const ActiveComponent =
    tabs.find((tab) => tab.id === activeTab)?.component || CustomerTrackingList;

  return (
    <div
      className="container-fluid d-flex flex-column justify-content-start align-items-center"
      style={{
        paddingBottom: "2.5rem",
        paddingTop: "clamp(1rem, 2vw, 2rem)",
        paddingLeft: "clamp(1rem, 5vw, 10rem)",
        paddingRight: "clamp(1rem, 5vw, 10rem)",
      }}
    >
      <div className="col-12">
        <div className="card shadow-sm rounded">
          {/* Tabs Header */}
          <div className="card-header bg-white border-bottom rounded-top">
            <ul className="nav nav-tabs card-header-tabs" role="tablist">
              {tabs.map((tab) => (
                <li key={tab.id} className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => (tab.id ? setActiveTab(tab.id) : undefined)}
                    type="button"
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content */}
          <div className="card-body">
            <ActiveComponent />
          </div>
        </div>
      </div>
    </div>
  );
}
